import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      closeButton={true}
      duration={5000}
      position="top-center"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:pr-12",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton: "!opacity-100 !visible !pointer-events-auto !absolute !top-2 !right-2 !w-7 !h-7 !min-w-7 !min-h-7 !flex !items-center !justify-center !rounded-full !bg-muted !border !border-border !text-foreground !cursor-pointer !z-50 hover:!bg-muted-foreground/20 [&>svg]:!w-3.5 [&>svg]:!h-3.5",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
